/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";

import { Button, Stack, Tab, Tabs } from "@mui/material";
import { Search } from "components";
import { Form, RoleTable, Table } from "components/Measures";
import { useActionHook } from "hooks";
import { useDealActions } from "store";
import { CreateMeasurePayload, IAssetClass, Measure } from "store/types";

const emptyMeasure: CreateMeasurePayload = {
  postfix: "",
  is_currency: true,
  is_global: true,
  is_global_value: false,
  is_negative: false,
  numerify: "",
  formula: "",
  calc_formula_cross_round: false,
  name: "",
  reduce_method_cross_round: "",
  reduce_method_cross_time: "",
  reduce_method_cross_deal: "",
  prime_role: null,
  is_absolute: false,
  description: null
};

export const Measures: React.FC = () => {
  const [measure, setMeasure] = useState<Measure | CreateMeasurePayload | null>(null);
  const [value, setValue] = useState<string>("");
  const [tab, setTab] = useState<number>(0);

  const { getMeasuresGroups, getAssetClassesAction } = useDealActions();
  const { action, data } = useActionHook(getMeasuresGroups);
  const { action: fetchAssetClasses, data: assetClasses } = useActionHook(getAssetClassesAction);

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const onDuplicate = useCallback(
    ({
      id,
      name,
      ...rest
    }: Measure & {
      measure_class: string;
    }) => {
      setMeasure({ ...emptyMeasure, ...rest });
    },
    []
  );

  useEffect(() => {
    action();
    fetchAssetClasses();
  }, [measure]);

  return (
    <>
      <Stack sx={{ bgcolor: "#f6f8fc", flexGrow: 1, overflow: "hidden", gap: "16px" }} alignItems="stretch">
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Search value={value} onChange={handleChange} placeholder="Search" />
          <Button variant="contained" onClick={() => setMeasure(emptyMeasure)}>
            Add Measures
          </Button>
        </Stack>
        <Tabs value={tab} onChange={(e, value) => setTab(value)}>
          <Tab value={0} label="Measures" />
          <Tab value={1} label="Measure Roles" />
        </Tabs>
        {tab == 0 && (
          <Table setMeasure={setMeasure} onDuplicate={onDuplicate} measuresGroups={data} searchValue={value} />
        )}
        {tab == 1 && <RoleTable searchValue={value} />}
      </Stack>
      {measure && <Form measure={measure} onClose={() => setMeasure(null)} measuresGroups={data} assetClasses={assetClasses ?? []} />}
    </>
  );
};
